import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var anchored = /*#__PURE__*/css(["border-radius:0;box-shadow:0 ", " ", " 0 rgba(0,0,0,0.2);"], pxToRem(2), pxToRem(4));
export var wrapper = /*#__PURE__*/css(["display:flex;margin:", ";padding:", ";border-radius:", ";"], stack(28), pxToRem(spacing.sm), pxToRem(10));
export var status = {
  alert: css(["background-color:var(--tertiary-yellow-50);"]),
  warning: css(["background-color:var(--tertiary-red-base);"]),
  success: css(["background-color:var(--tertiary-green-50);"]),
  default: css(["background-color:var(--neutral-black-30);"])
};

/**
 * #1 - The width and height on the Icon components are currently set in px, so using px
 * instead of rem here until that has been refactored to use rem.
 * #2 - Although the Icon components set a width on the icon, min-width is needed to
 * prevent flexbox shrinking the icon when the text reaches the end of the component.
 */
export var icon = /*#__PURE__*/css(["align-self:flex-start;min-width:24px;"]);
export var iconButton = /*#__PURE__*/css(["padding:0;border:none;background:none;cursor:pointer;"]);
export var message = /*#__PURE__*/css(["margin:0 0 0 ", ";align-self:center;text-align:left;flex-grow:1;"], pxToRem(12));